ux-iws-teaser-download-document {
    align-items: stretch;
    display: flex;
    height: 100%;
    width: 100%;
}

.ux-iws-teaser-download-document {
    background-color: #fff;
    cursor: pointer;
    align-items: stretch;
    display: flex !important;
    width: 100%;

    &__inner {
        padding: 20px;
        margin: 0;
        position: relative;
        border-bottom: 1px solid #e2e2e2;
        border-top: 1px solid #e2e2e2;
        display: flex;
        width: 100%;
    }

    &__image {
        flex-shrink: 0;
    }

    &__image-outer {
        position: relative;
        display: block;
        margin: 0;
        text-align: center;
        max-width: 100%;
    }

    &__image-inner {
        position: relative;
        box-shadow: 0 7px 22px rgba(19, 19, 19, 0.08);
        overflow: hidden;

        img {
            transition: transform 0.5s ease-in-out;
            width: 79px;
            height: 112px;
            display: block;
        }

        // fallback icon
        ux-icon {
            position: absolute;
            left: calc(50% - 10px);
            top: calc(50% - 10px);
            font-size: 20px;
            color: #fff;
        }
    }

    &:hover .ux-iws-teaser-download-document__image-inner img {
        transform: scale(1.03);
    }

    &__image-overlay {
        background-color: #285172;
        position: absolute;
        margin: auto;
        width: 100%;
        bottom: 0;
        left: 0;
        right: 0;
        color: #fff;
        text-align: center;
        font-family: "Frutiger-Light", sans-serif;
        font-size: 13px;
        line-height: 1.6;
    }

    &__content {
        flex-grow: 1;
        padding: 0 30px 0 20px;
    }

    &__info,
    &__size {
        text-transform: uppercase;
        font-size: 15px;
        font-family: "Frutiger-Light", sans-serif;
        color: #727272;
        display: inline-block;
        margin-bottom: 4px;
        margin-right: 15px;
    }

    &__title {
        font-size: 18px;
        font-family: "Frutiger-Bold", sans-serif;
        color: #393939;
        max-width: 100%;
        white-space: normal;
        overflow-wrap: break-word;
        word-break: break-word;
    }

    &__description {
        font-size: 14px;
        font-family: "Frutiger-Light", sans-serif;
        color: #727272;
        max-width: 100%;
        white-space: normal;
        overflow-wrap: break-word;
        word-break: break-word;
    }

    &__link {
        align-self: end;
    }
}
